import { __assign, __awaiter, __decorate, __generator, __metadata } from "tslib";
import { tryCatchHandler } from '../../base/decorators';
import { isValidEncId } from '../../base/utils/check';
import DocMetaEntity from '../entity/doc-meta-entity';
import { DocCreatorInfo } from '../value-object/doc-creator-info';
import { DocOwnerInfo } from '../value-object/doc-owner-info';
import { DocPadInfo } from '../value-object/doc-pad-info';
import { DocPersonalizeInfo } from '../value-object/doc-personalize-info';
import { DocTitleInfo } from '../value-object/doc-title-info';
import { DocUserAuthInfo } from '../value-object/doc-user-auth-info';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
var DOC_META_ENTITY_UUID = 'MainDocMetaEntity';
var DocMetaDomainService = /** @class */ (function () {
    function DocMetaDomainService() {
        this.isInitedByBasicClientVars = false;
        this.docMetaEntity = new DocMetaEntity(DOC_META_ENTITY_UUID);
        if (window === null || window === void 0 ? void 0 : window.basicClientVars) {
            this.initWithBasicClientVars(window.basicClientVars);
        }
    }
    DocMetaDomainService.prototype.updateWithClientVars = function (clientVars) {
        if (this.isInitedByBasicClientVars) {
            return;
        }
        this.docMetaEntity.createInfo = new DocCreatorInfo(__assign(__assign({}, clientVars), { createTime: clientVars.metaCreateTime }));
        this.docMetaEntity.ownerInfo = new DocOwnerInfo(clientVars);
        this.docMetaEntity.padInfo = new DocPadInfo(clientVars);
        this.docMetaEntity.titleInfo = new DocTitleInfo(clientVars);
        this.docMetaEntity.userAuthInfo = new DocUserAuthInfo(clientVars);
    };
    DocMetaDomainService.prototype.init = function (requestParam) {
        return __awaiter(this, void 0, void 0, function () {
            var docId, addRecent, fileInfoRsp, _a, docInfo, fileMeta, privilege;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        docId = requestParam.docId, addRecent = requestParam.addRecent;
                        if (!isValidEncId(docId))
                            return [2 /*return*/];
                        return [4 /*yield*/, this.docMetaEntity.fetchFileInfo(docId, addRecent)];
                    case 1:
                        fileInfoRsp = _e.sent();
                        _a = (_d = (_c = (_b = fileInfoRsp.resData) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.result) !== null && _d !== void 0 ? _d : {}, docInfo = _a.docInfo, fileMeta = _a.fileMeta, privilege = _a.privilege;
                        this.docMetaEntity.createInfo = new DocCreatorInfo({
                            isCreator: docInfo === null || docInfo === void 0 ? void 0 : docInfo.isCreator,
                            creatorDomain: docInfo === null || docInfo === void 0 ? void 0 : docInfo.domainId,
                            creatorId: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.creator,
                            creatorCorpId: '',
                            creatorCorpName: '',
                        });
                        this.docMetaEntity.padInfo = new DocPadInfo({
                            domainId: docInfo === null || docInfo === void 0 ? void 0 : docInfo.domainId,
                            padId: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.fileId,
                            padType: docInfo === null || docInfo === void 0 ? void 0 : docInfo.padType,
                            relative: [],
                            docStatus: docInfo === null || docInfo === void 0 ? void 0 : docInfo.docStatus,
                        });
                        this.docMetaEntity.titleInfo = new DocTitleInfo({
                            title: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.name,
                            isUserChangeTitle: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.userChangeFilename,
                        });
                        this.docMetaEntity.userAuthInfo = new DocUserAuthInfo({
                            isCreator: docInfo === null || docInfo === void 0 ? void 0 : docInfo.isCreator,
                            isOwner: docInfo === null || docInfo === void 0 ? void 0 : docInfo.isOwner,
                            isAdmin: privilege === null || privilege === void 0 ? void 0 : privilege.attribute.isAdmin,
                        });
                        this.docMetaEntity.collaborationFlag = fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.collaborationFlag;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 根据 basicClientVars 初始化 docMeta 数据
     * @param basicClientVars window.basicClientVars
     */
    DocMetaDomainService.prototype.initWithBasicClientVars = function (basicClientVars) {
        this.updateCreateInfoByBasicClientVars(basicClientVars);
        this.updateOwnerAndAuthInfoByBasicClientVars(basicClientVars);
        this.updatePadInfoByBasicClientVars(basicClientVars);
        this.updateTitleInfoByBasicClientVars(basicClientVars);
        this.updateCollaborationInfoByBasicClientVars(basicClientVars);
        this.updatePersonalizeInfoByBasicClientVars(basicClientVars);
        this.isInitedByBasicClientVars = true;
    };
    /**
     * 更新 DocPersonalizeInfo 个人装扮等数据
     */
    DocMetaDomainService.prototype.updatePersonalizeInfoByBasicClientVars = function (basicClientVars) {
        var _a;
        this.docMetaEntity.personalizeInfo = new DocPersonalizeInfo((_a = basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.personalizeInfo);
    };
    /**
     * 更新 collaborationFlag 协作空间等数据
     */
    DocMetaDomainService.prototype.updateCollaborationInfoByBasicClientVars = function (basicClientVars) {
        var _a;
        this.docMetaEntity.collaborationFlag = (_a = basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.collaborationFlag;
    };
    /**
     * 更新 docMetaEntity.createInfo 数据
     */
    DocMetaDomainService.prototype.updateCreateInfoByBasicClientVars = function (basicClientVars) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        this.docMetaEntity.createInfo = new DocCreatorInfo({
            isCreator: (_a = basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.isOwner,
            creatorDomain: (_c = (_b = basicClientVars.docInfo) === null || _b === void 0 ? void 0 : _b.padInfo) === null || _c === void 0 ? void 0 : _c.domainId,
            creatorNick: (_e = (_d = basicClientVars.docInfo) === null || _d === void 0 ? void 0 : _d.createInfo) === null || _e === void 0 ? void 0 : _e.creatorNick,
            createTime: (_g = (_f = basicClientVars.docInfo) === null || _f === void 0 ? void 0 : _f.createInfo) === null || _g === void 0 ? void 0 : _g.createTime,
            creatorId: (_j = (_h = basicClientVars.docInfo) === null || _h === void 0 ? void 0 : _h.createInfo) === null || _j === void 0 ? void 0 : _j.creatorId,
            creatorCorpId: (_l = (_k = basicClientVars.docInfo) === null || _k === void 0 ? void 0 : _k.createInfo) === null || _l === void 0 ? void 0 : _l.creatorCorpId,
            creatorCorpName: (_o = (_m = basicClientVars.docInfo) === null || _m === void 0 ? void 0 : _m.createInfo) === null || _o === void 0 ? void 0 : _o.creatorCorpName,
        });
    };
    /**
     * 更新 docMetaEntity.ownerInfo 与 docMetaEntity.userAuthInfo 数据
     */
    DocMetaDomainService.prototype.updateOwnerAndAuthInfoByBasicClientVars = function (basicClientVars) {
        var _a, _b, _c, _d, _e;
        this.docMetaEntity.ownerInfo = new DocOwnerInfo((_a = basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.ownerInfo);
        this.docMetaEntity.userAuthInfo = new DocUserAuthInfo({
            isCreator: (_b = basicClientVars.docInfo) === null || _b === void 0 ? void 0 : _b.isOwner,
            isOwner: (_c = basicClientVars.docInfo) === null || _c === void 0 ? void 0 : _c.isOwner,
            isAdmin: (_d = basicClientVars.docInfo) === null || _d === void 0 ? void 0 : _d.isAdmin,
            // privilegeFlag 这个枚举目前 docs-shared-types 里没加，加上后再替换
            isViewer: ((_e = basicClientVars.authInfo) === null || _e === void 0 ? void 0 : _e.privilegeFlag) === 1,
        });
    };
    /**
     * 更新 docMetaEntity.padInfo 数据
     */
    DocMetaDomainService.prototype.updatePadInfoByBasicClientVars = function (basicClientVars) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        // TODO: type 未由 basicClientVars.docInfo 提供
        this.docMetaEntity.padInfo = new DocPadInfo({
            domainId: (_b = (_a = basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.padInfo) === null || _b === void 0 ? void 0 : _b.domainId,
            padId: (_d = (_c = basicClientVars.docInfo) === null || _c === void 0 ? void 0 : _c.padInfo) === null || _d === void 0 ? void 0 : _d.padId,
            padType: (_f = (_e = basicClientVars.docInfo) === null || _e === void 0 ? void 0 : _e.padInfo) === null || _f === void 0 ? void 0 : _f.padType,
            relative: (_h = (_g = basicClientVars.docInfo) === null || _g === void 0 ? void 0 : _g.padInfo) === null || _h === void 0 ? void 0 : _h.relative,
            docStatus: (_j = basicClientVars.docInfo) === null || _j === void 0 ? void 0 : _j.docStatus,
            shareLink: (_k = basicClientVars.docInfo) === null || _k === void 0 ? void 0 : _k.shareLink,
            lastModifyTime: (_l = basicClientVars.docInfo) === null || _l === void 0 ? void 0 : _l.lastModifyTime,
            lastModifyUser: (_m = basicClientVars.docInfo) === null || _m === void 0 ? void 0 : _m.lastModifyUser,
        });
    };
    /**
     * 更新 docMetaEntity.titleInfo 数据
     */
    DocMetaDomainService.prototype.updateTitleInfoByBasicClientVars = function (basicClientVars) {
        var _a, _b, _c;
        this.docMetaEntity.titleInfo = new DocTitleInfo({
            title: (_b = (_a = basicClientVars.docInfo) === null || _a === void 0 ? void 0 : _a.padInfo) === null || _b === void 0 ? void 0 : _b.padTitle,
            isUserChangeTitle: (_c = basicClientVars.docInfo) === null || _c === void 0 ? void 0 : _c.isUserChangeTitle,
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], DocMetaDomainService.prototype, "init", null);
    __decorate([
        tryCatchHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DocMetaDomainService.prototype, "initWithBasicClientVars", null);
    return DocMetaDomainService;
}());
export { DocMetaDomainService };
